import React, { Suspense, useEffect, useState } from "react";
import { Redirect, Route, Router, Switch } from "react-router-dom";
import { history } from "../_config";
import {
  GROUPPAGE_ROUTE,
  GROUPPAGE_SLUG_ROUTE,
  LOGIN_EMAIL_ROUTE,
  LOGIN_ROUTE,
  REGISTER_EMAIL_ROUTE,
  REGISTER_ROUTE,
  SECTIONPAGE_SLUG_ROUTE,
} from "../_pages";
import {
  CreateCommunityPage,
  CREATE_COMMUNITY_ROUTE,
} from "../_pages/create-community.page";
import { LEADERBOARD_PAGE_ROUTE } from "../_pages/leaderboard.page";
import {
  NotificationPage,
  NOTIFICATION_PAGE_ROUTE,
} from "../_pages/notification.page";
import { UserWallPage, USER_WALL_PAGE_ROUTE } from "../_pages/user-wall.page";
import { store } from "../_store";
import { getCommunityGroups } from "../_store/_actions/community.actions";
import { getPersonalGroup } from "../_store/_actions/personal-group.actions";
import { CreateGroupModal } from "./group/create-group-modal.component";
import { CreateSectionModal } from "./group/create-section-modal.component";
import { ProfileUpdate } from "./profile/profile-update.component";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SocketClient from "socket.io-client";
import { withToast } from "../contexts/toastr.context";
import useSocketListeners from "../hooks/use-socket-listeners.hook";
import { socketEndpointBase } from "../_config/endpoint.config/endpoint.config";
import { mixPanel } from "../_config/mixpanel.config";
import NotFoundPage from "../_pages/404-not-found";
import { APP_SUMO_SUCCESS_ROUTE } from "../_pages/app-sumo-sucess.page";
import { COMMUNITY_HOMEPAGE_ROUTE } from "../_pages/community-home/community-home.page";
import { COMMUNITY_BANNER_SETTINGS_PAGE_ROUTE } from "../_pages/community-settings/community-banner-settings.page";
import { COMMUNITY_SETTING_PAGE_ROUTE } from "../_pages/community-settings/community-experience-setting.page";
import { COMMUNITY_UPDATE_PAGE_ROUTE } from "../_pages/community-settings/community-general-settings.page";
import { COMMUNITY_SUBSCRIPTION_PAGE_ROUTE } from "../_pages/community-settings/community-subscription.page";
import { COMMUNITY_THEME_SELECTOR_PAGE_ROUTE } from "../_pages/community-settings/community-theme-selector.page";
import { COMMUNITY_CUSTOM_DOMAIN_SETUP_PAGE_ROUTE } from "../_pages/community-settings/custom-domain-setup.page";
import { COMMUNITY_SETTING_CUSTOM_DOMAIN_PAGE_ROUTE } from "../_pages/community-settings/custom-subdomain.page";
import { COMMUNITY_SETTING_EMBEDDED_SECTION_EDIT_PAGE_ROUTE } from "../_pages/community-settings/embedded-section-edit.page";
import { COMMUNITY_SETTING_EMBEDDED_SECTION_PAGE_ROUTE } from "../_pages/community-settings/embedded-sections.page";
import { COMMUNITY_SETTING_LEADERBOARD_RELATED_PAGE_ROUTE } from "../_pages/community-settings/leaderboard-related-page";
import { MEMBERSHIPS_PAGE_ROUTE } from "../_pages/community-settings/membership/membership-page";
import { NOTIFICATION_CENTRE_PAGE_ROUTE } from "../_pages/community-settings/notification-centre.page";
import { COMMUNITY_PAYWALL_SETTINGS_PAGE_ROUTE } from "../_pages/community-settings/paywall/paywall-settings.page";
import { USER_PROFILE_UPDATE_PAGE_ROUTE } from "../_pages/community-settings/profile-update.page";
import { USER_API_KEYS_PAGE_ROUTE } from "../_pages/community-settings/user-apis.page";
import { COMMUNITY_SETTING_WELCOME_MESSAGES_PAGE_ROUTE } from "../_pages/community-settings/welcome-messages.page";
import { COURSE_DETAIL_PAGE_ROUTE } from "../_pages/course/course-detail/course-detail.page";
import { COURSE_VIEW_PAGE_ROUTE } from "../_pages/course/course-view/course-view.page";
import { COURSE_PAGE_ROUTE } from "../_pages/course/course.page";
import { DIRECT_MESSAGE_PAGE_ROUTE } from "../_pages/direct-message/direct-message.page";
import { EMBEDDED_SECTION_PAGE_ROUTE } from "../_pages/embedded-section-detail.page";
import {
  EVENTS_DETAIL_PAGE_ROUTE,
  EVENTS_DETAIL_SLUG_PAGE_ROUTE,
} from "../_pages/event-detail.page";
import { COMMUNITY_EVENTS_PAGE_ROUTE } from "../_pages/events-page";
import { JOIN_COMMUNITY_PAGE_ROUTE } from "../_pages/join-community.page";
import { NTFS_PAGE_ROUTE } from "../_pages/nfts-page";
import { SUBSCRIPTION_CHECKOUT_PAGE } from "../_pages/payment-checkout/payment-checkout.page";
import {
  POST_DETAIL_PAGE_ROUTE,
  POST_DETAIL_SLUG_PAGE_ROUTE,
} from "../_pages/post-detail.page";
import { ACCOUNT_VERIFICATION_PAGE_ROUTE } from "../_pages/settings/contact-verification.page";
import { TAG_PAGE_ROUTE } from "../_pages/tag-details.page";
import { BULK_MAIL_PAGE_ROUTE } from "../_pages/user-management-settings/bulk-mail";
import { SEND_BULK_MAIL_PAGE_ROUTE } from "../_pages/user-management-settings/bulk-mail/component/send-bulk-mail.component";
import { CUSTOM_PUSH_PAGE_ROUTE } from "../_pages/user-management-settings/custom-push";
import { INVITE_MEMBERS_SETTINGS_PAGE_ROUTE } from "../_pages/user-management-settings/invite-user-settings.page";
import { SUBSCRIPTION_PAGE_ROUTE } from "../_pages/user-management-settings/subscriptions/subscriptions-list/subscriptions-page";
import { USERS_MANAGEMENT_SETTINGS_PAGE_ROUTE } from "../_pages/user-management-settings/users-management-settings.page";
import { getHighlightedPosts } from "../_store/highlighted-posts.store";
import { getMySubscription } from "../_store/subscription/my-subscription/my-subscription.action";
import { getSubscriptions } from "../_store/subscription/subscription-plan.action";
import {
  getAllDirectChats,
  getAllDirectChatsSuccessAction,
} from "../_store/_actions/direct-message.actions";
import { getNotificationPreference } from "../_store/_actions/notification-centre.actions";
import {
  addNotification,
  getNotifications,
} from "../_store/_actions/notification.actions";
import { setSocket } from "../_store/_actions/socket.actions";
import Validator from "../_utils/validator";
import CommunitySettingsSidebar from "./community/community-settings-sidebar.component";
import CommunityUpgradeNudge from "./community/community-upgrade-nudge.component";
import MobileAppPopup from "./community/mobile-app-popup.component";
import SideCommunitySwitcher from "./community/side-community-switcher.component";
import FontHelmet from "./helmets/font.helmet";
import HeaderShimmer from "./shimmers/header/header-shimmer.component";
import SidebarShimmer from "./shimmers/sidebar/sidebar-empty-shimmer.component";

import communitySpecificConfig from "../_config/community-specific-config";
import { loadScript } from "../_config/helper.config";
import { Loader } from "./loader.component";

// lazy loaded components
const Header = React.lazy(() => import("./header.component/index"));
const Sidebar = React.lazy(() => import("./sidebar.component"));

// lazy loaded pages
const GroupPage = React.lazy(() => import("../_pages/group/group.page"));
const PostDetailPage = React.lazy(() => import("../_pages/post-detail.page"));
const PaymentCheckoutPage = React.lazy(() =>
  import("../_pages/payment-checkout/payment-checkout.page")
);
const AppSumoSuccessPage = React.lazy(() =>
  import("../_pages/app-sumo-sucess.page")
);
const CommunityHomePage = React.lazy(() =>
  import("../_pages/community-home/community-home.page")
);
const UserManagementSettingsPage = React.lazy(() =>
  import("../_pages/user-management-settings/users-management-settings.page")
);
const CommunitySelectorPage = React.lazy(() =>
  import("../_pages/community-selector.page")
);
const CommunityBannerSettingsPage = React.lazy(() =>
  import("../_pages/community-settings/community-banner-settings.page")
);
const CommunitySettingsPage = React.lazy(() =>
  import("../_pages/community-settings/community-experience-setting.page")
);
const CommunityUpdatePage = React.lazy(() =>
  import("../_pages/community-settings/community-general-settings.page")
);
const CommunityThemeSelectorPage = React.lazy(() =>
  import("../_pages/community-settings/community-theme-selector.page")
);
const CustomDomainSetupPage = React.lazy(() =>
  import("../_pages/community-settings/custom-domain-setup.page")
);
const CommunitySettingsCustomDomainPage = React.lazy(() =>
  import("../_pages/community-settings/custom-subdomain.page")
);
const CommunitySettingEmbeddedSectionEditPage = React.lazy(() =>
  import("../_pages/community-settings/embedded-section-edit.page")
);
const CommunitySettingEmbeddedSectionsPage = React.lazy(() =>
  import("../_pages/community-settings/embedded-sections.page")
);
const CommunitySettingsLeaderboardRelatedPage = React.lazy(() =>
  import("../_pages/community-settings/leaderboard-related-page")
);
const MembershipsPage = React.lazy(() =>
  import("../_pages/community-settings/membership/membership-page")
);
const NotificationCentrePage = React.lazy(() =>
  import("../_pages/community-settings/notification-centre.page")
);
const UserProfileUpdatePage = React.lazy(() =>
  import("../_pages/community-settings/profile-update.page")
);
const UserApiKeysPage = React.lazy(() =>
  import("../_pages/community-settings/user-apis.page")
);
const CommunitySettingsWelcomeMessagesPage = React.lazy(() =>
  import("../_pages/community-settings/welcome-messages.page")
);
const CourseDetailPage = React.lazy(() =>
  import("../_pages/course/course-detail/course-detail.page")
);
const CourseViewPage = React.lazy(() =>
  import("../_pages/course/course-view/course-view.page")
);
const CoursePage = React.lazy(() => import("../_pages/course/course.page"));
const DirectMessagePage = React.lazy(() =>
  import("../_pages/direct-message/direct-message.page")
);
const EmbeddedSectionDetailPage = React.lazy(() =>
  import("../_pages/embedded-section-detail.page")
);
const EventDetailPage = React.lazy(() => import("../_pages/event-detail.page"));
const EventsPage = React.lazy(() => import("../_pages/events-page"));
const JoinCommunityPage = React.lazy(() =>
  import("../_pages/join-community.page")
);
const NTFsPage = React.lazy(() => import("../_pages/nfts-page"));
const AccountVerificationPage = React.lazy(() =>
  import("../_pages/settings/contact-verification.page")
);
const TagPageDetails = React.lazy(() => import("../_pages/tag-details.page"));

const PaywallPage = React.lazy(() =>
  import("../_pages/community-settings/paywall/paywall-settings.page")
);
const CommunitySubscriptionPage = React.lazy(() =>
  import("../_pages/community-settings/community-subscription.page")
);

function AuthAppComponent({
  // state
  user,
  community,
  socket,
  notifications,
  groups,
  personalGroup,
  isLoadingGroups,
  chats,
  // dispatches
  setChats,
  addNewNotification,
  addToast,
  addToastWithAction,
  notificationCentre,
  getAllDirectChats,
  subscriptionsPlan,
  mySubscription,
}) {
  const [isCreateGroupModalVisible, setIsCreateGroupModalVisible] =
    useState(false);
  const [isCreateSectionModalVisible, setIsCreateSectionModalVisible] =
    useState(false);
  const [isPersonalSpace, setIsPersonalSpace] = useState(false);

  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  const [notificationsFetched, setNotificationsFetched] = useState(false);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showDirectMessage, setShowDirectMessage] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const urlParams = new URLSearchParams(window.location.search);
  const action = urlParams.get("action");

  const [sidebarIgnoresCommunitySwitcher, setSidebarIgnoresCommunitySwitcher] =
    useState(false); // for making sidebar ignore community switcher on 0 communities (or 1)

  //handle direct message sidebar
  useEffect(() => {
    const handleResize = () => {
      setShowDirectMessage(window.innerWidth <= 982);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Update the current path.
  useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, [urlParams]);

  // initialize socket
  useEffect(() => {
    store.dispatch(setSocket(new SocketClient(socketEndpointBase)));
  }, []);

  // load google adsense script if community has google adsense id
  React.useEffect(() => {
    const config = communitySpecificConfig;
    if (!config || !config.googleAdsenseId) {
      return;
    }
    loadScript(
      `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${config.googleAdsenseId}`,
      "google-adsense-script",
      true,
      true
    ).then((res) => {
      console.log("Google adsense script  loaded", {
        Ads: window.adsbygoogle,
        Id: config.googleAdsenseId,
      });
    });
  }, []);

  useSocketListeners({
    socket,
    addNewNotification,
    addToastWithAction,
    community,
    chats,
    setChats,
  });

  // init mixpanel and identify user
  useEffect(() => {
    if (user) {
      mixPanel.identify(user.id);
      mixPanel.people.set({
        $email: user.email,
        $name: user.name,
        $mobile: user.mobile,
        $avatar: user.picture,
      });
    }
  }, [user]);

  // trigger store update
  useEffect(() => {
    // get all groups
    if (community) {
      if (groups.length === 0 && isLoadingGroups) {
        store.dispatch(getCommunityGroups());
      }
      if (!notificationCentre.preferences) {
        store.dispatch(getNotificationPreference());
      }
    } else {
      // don't get group for now
      // if (groups.length === 0) {
      //     store.dispatch(getGroups());
      // }
      if (!personalGroup) {
        store.dispatch(getPersonalGroup());
      }
    }
    // get all notification
    if (!notificationsFetched) {
      store.dispatch(getNotifications());
      setNotificationsFetched(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [community, groups, personalGroup, notifications, subscriptionsPlan]);

  // trigger store update
  const communityId = community?.id;

  useEffect(() => {
    if (communityId) {
      // get highlighted posts
      store.dispatch(getHighlightedPosts(communityId));
    }
    // Get all subscriptions
    if (!Validator.hasValue(subscriptionsPlan?.subscriptions)) {
      store.dispatch(getSubscriptions());
    }
  }, [communityId, subscriptionsPlan?.subscriptions]);

  // get all direct chats
  useEffect(() => {
    getAllDirectChats();
    // Get my subscription
    if (!Validator.hasValue(mySubscription)) {
      store.dispatch(getMySubscription());
    }
  }, [user]);

  return (
    <div className="AuthApp">
      <FontHelmet community={community} />
      <MobileAppPopup community={community} />
      <Router history={history}>
        {user ? <ProfileUpdate /> : <></>}
        {!currentPath.startsWith("/course/view/") && (
          <Suspense fallback={<HeaderShimmer />}>
            <Header
              action={action}
              isSidebarOpen={isSidebarOpen}
              setIsSidebarOpen={setIsSidebarOpen}
            />
          </Suspense>
        )}
        <div
          className={
            community
              ? `AppContainer ${getExtraClassForAppContainerUsingPath(
                  currentPath,
                  community,
                  user
                )}`
              : ""
          }>
          {" "}
          {/* only use app container in case of community */}
          <Suspense fallback={<SidebarShimmer />}>
            {
              // show sidebar and switcher only if community is selected
              community && (
                <>
                  {user && !community.isCommunitySwitcherDisabled ? (
                    <SideCommunitySwitcher
                      community={community}
                      isVisible={isSidebarOpen}
                      setSidebarIgnoresCommunitySwitcher={
                        setSidebarIgnoresCommunitySwitcher
                      }
                    />
                  ) : null}
                  {
                    window.location.pathname.startsWith("/settings") && user ? (
                      <CommunitySettingsSidebar
                        isSidebarOpen={isSidebarOpen}
                        setIsSidebarOpen={setIsSidebarOpen}
                        sidebarIgnoresCommunitySwitcher={
                          sidebarIgnoresCommunitySwitcher
                        }
                      />
                    ) : window.location.pathname.startsWith(
                        "/direct-message"
                      ) ? (
                      showDirectMessage && (
                        <Sidebar
                          sidebarIgnoresCommunitySwitcher={
                            sidebarIgnoresCommunitySwitcher
                          }
                          isSidebarOpen={isSidebarOpen}
                          setIsSidebarOpen={setIsSidebarOpen}
                        />
                      )
                    ) : window.location.pathname.startsWith("/course/view/") ? (
                      <></>
                    ) : (
                      // <div></div>
                      <Sidebar
                        sidebarIgnoresCommunitySwitcher={
                          sidebarIgnoresCommunitySwitcher
                        }
                        isSidebarOpen={isSidebarOpen}
                        setIsSidebarOpen={setIsSidebarOpen}
                        isCreateGroupModalVisible={isCreateGroupModalVisible}
                        setIsCreateGroupModalVisible={
                          setIsCreateGroupModalVisible
                        }
                        isCreateSectionModalVisible={
                          isCreateSectionModalVisible
                        }
                        setIsCreateSectionModalVisible={
                          setIsCreateSectionModalVisible
                        }
                        setIsPersonalSpace={setIsPersonalSpace}
                        isPersonalSpace={isPersonalSpace}
                      />
                    )
                    // <div></div>
                  }
                </>
              )
            }
          </Suspense>
          <Switch>
            <Route path={COMMUNITY_HOMEPAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                {community ? <CommunityHomePage /> : <CommunitySelectorPage />}
              </Suspense>
            </Route>
            <Route path={GROUPPAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <GroupPage
                  isCreateSectionModalVisible={isCreateSectionModalVisible}
                  setIsCreateSectionModalVisible={
                    setIsCreateSectionModalVisible
                  }
                  setIsPersonalSpace={setIsPersonalSpace}
                />
              </Suspense>
            </Route>
            <Route path={GROUPPAGE_SLUG_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <GroupPage
                  isCreateSectionModalVisible={isCreateSectionModalVisible}
                  setIsCreateSectionModalVisible={
                    setIsCreateSectionModalVisible
                  }
                  setIsPersonalSpace={setIsPersonalSpace}
                />
              </Suspense>
            </Route>
            <Route path={SECTIONPAGE_SLUG_ROUTE}>
              <Suspense fallback={<Loader />}>
                <GroupPage
                  isCreateSectionModalVisible={isCreateSectionModalVisible}
                  setIsCreateSectionModalVisible={
                    setIsCreateSectionModalVisible
                  }
                  setIsPersonalSpace={setIsPersonalSpace}
                />
              </Suspense>
            </Route>
            <Route path={POST_DETAIL_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <PostDetailPage />
              </Suspense>
            </Route>
            <Route path={POST_DETAIL_SLUG_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <PostDetailPage />
              </Suspense>
            </Route>
            <Route path={TAG_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <TagPageDetails community={community} />
              </Suspense>
            </Route>
            <Route path={USER_WALL_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <UserWallPage />
              </Suspense>
            </Route>
            <Route path={NOTIFICATION_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <NotificationPage />
              </Suspense>
            </Route>
            <Route path={JOIN_COMMUNITY_PAGE_ROUTE}>
              <Suspense fallback={<Loader />}>
                <JoinCommunityPage />
              </Suspense>
            </Route>
            <Route path={CREATE_COMMUNITY_ROUTE}>
              <Suspense fallback={<Loader />}>
                <CreateCommunityPage />
              </Suspense>
            </Route>
            <Route path={SUBSCRIPTION_CHECKOUT_PAGE}>
              <Suspense fallback={<Loader />}>
                <PaymentCheckoutPage />
              </Suspense>
            </Route>
            <Route path={COMMUNITY_EVENTS_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <EventsPage />
              </Suspense>
            </Route>
            <Route path={EVENTS_DETAIL_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <EventDetailPage />
              </Suspense>
            </Route>
            <Route path={COURSE_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <CoursePage />
              </Suspense>
            </Route>
            <Route path={COURSE_DETAIL_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <CourseDetailPage />
              </Suspense>
            </Route>
            <Route path={EVENTS_DETAIL_SLUG_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <EventDetailPage />
              </Suspense>
            </Route>
            <Route path={EMBEDDED_SECTION_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <EmbeddedSectionDetailPage />
              </Suspense>
            </Route>
            <Route path={NTFS_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <NTFsPage />
              </Suspense>
            </Route>
            {/* login redirects */}
            <Route path={LOGIN_ROUTE} exact>
              <Redirect
                to={COMMUNITY_HOMEPAGE_ROUTE + window.location.search}
              />
            </Route>
            <Route path={LOGIN_EMAIL_ROUTE} exact>
              <Redirect
                to={COMMUNITY_HOMEPAGE_ROUTE + window.location.search}
              />
            </Route>
            <Route path={REGISTER_EMAIL_ROUTE} exact>
              <Redirect
                to={COMMUNITY_HOMEPAGE_ROUTE + window.location.search}
              />
            </Route>
            <Route path={REGISTER_ROUTE}>
              <Redirect
                to={COMMUNITY_HOMEPAGE_ROUTE + window.location.search}
              />
            </Route>
            {/* third party */}
            <Route path={APP_SUMO_SUCCESS_ROUTE}>
              <Suspense fallback={<Loader />}>
                <AppSumoSuccessPage />
              </Suspense>
            </Route>
            {/* community setting pages */}
            <Route path={COMMUNITY_SETTING_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <CommunitySettingsPage />
              </Suspense>
            </Route>
            {/* community setting pages */}
            <Route path={COMMUNITY_SETTING_CUSTOM_DOMAIN_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <CommunitySettingsCustomDomainPage />
              </Suspense>
            </Route>
            <Route path={COMMUNITY_SUBSCRIPTION_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <CommunitySubscriptionPage />
              </Suspense>
            </Route>
            <Route path={COMMUNITY_UPDATE_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <CommunityUpdatePage />
              </Suspense>
            </Route>
            <Route path={COMMUNITY_BANNER_SETTINGS_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <CommunityBannerSettingsPage />
              </Suspense>
            </Route>
            <Route path={COMMUNITY_SETTING_WELCOME_MESSAGES_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <CommunitySettingsWelcomeMessagesPage />
              </Suspense>
            </Route>
            <Route path={COMMUNITY_THEME_SELECTOR_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <CommunityThemeSelectorPage />
              </Suspense>
            </Route>
            <Route path={COMMUNITY_CUSTOM_DOMAIN_SETUP_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <CustomDomainSetupPage />
              </Suspense>
            </Route>
            <Route
              path={COMMUNITY_SETTING_LEADERBOARD_RELATED_PAGE_ROUTE}
              exact>
              <Suspense fallback={<Loader />}>
                <CommunitySettingsLeaderboardRelatedPage />
              </Suspense>
            </Route>
            <Route path={COMMUNITY_PAYWALL_SETTINGS_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <PaywallPage />
              </Suspense>
            </Route>
            <Route
              path={COMMUNITY_SETTING_EMBEDDED_SECTION_EDIT_PAGE_ROUTE}
              exact>
              <Suspense fallback={<Loader />}>
                <CommunitySettingEmbeddedSectionEditPage />
              </Suspense>
            </Route>
            <Route path={COMMUNITY_SETTING_EMBEDDED_SECTION_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <CommunitySettingEmbeddedSectionsPage />
              </Suspense>
            </Route>
            {/* user setting pages */}
            <Route path={USER_API_KEYS_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <UserApiKeysPage />
              </Suspense>
            </Route>
            <Route path={USER_PROFILE_UPDATE_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <UserProfileUpdatePage />
              </Suspense>
            </Route>

            <Route path={ACCOUNT_VERIFICATION_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <AccountVerificationPage />
              </Suspense>
            </Route>
            {user && community && (
              <Route path={DIRECT_MESSAGE_PAGE_ROUTE} exact>
                <Suspense fallback={<Loader />}>
                  <DirectMessagePage />
                </Suspense>
              </Route>
            )}
            <Route path={USERS_MANAGEMENT_SETTINGS_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <UserManagementSettingsPage />
              </Suspense>
            </Route>
            <Route path={NOTIFICATION_CENTRE_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <NotificationCentrePage />
              </Suspense>
            </Route>
            <Route path={MEMBERSHIPS_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <MembershipsPage />
              </Suspense>
            </Route>
            <Route path={LEADERBOARD_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <UserManagementSettingsPage />
              </Suspense>
            </Route>

            <Route path={INVITE_MEMBERS_SETTINGS_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <UserManagementSettingsPage />
              </Suspense>
            </Route>
            <Route path={BULK_MAIL_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <UserManagementSettingsPage />
              </Suspense>
            </Route>
            <Route path={SUBSCRIPTION_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <UserManagementSettingsPage />
              </Suspense>
            </Route>
            <Route path={CUSTOM_PUSH_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <UserManagementSettingsPage />
              </Suspense>
            </Route>
            <Route path={SEND_BULK_MAIL_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <UserManagementSettingsPage />
              </Suspense>
            </Route>
            <Route path={COURSE_VIEW_PAGE_ROUTE} exact>
              <Suspense fallback={<Loader />}>
                <CourseViewPage />
              </Suspense>
            </Route>
            <Route path="*">
              <NotFoundPage />
            </Route>
          </Switch>
        </div>
        {/* modals */}
        <CreateGroupModal
          community={community}
          active={isCreateGroupModalVisible}
          setActive={setIsCreateGroupModalVisible}
        />
        <CreateSectionModal
          community={community}
          active={isCreateSectionModalVisible}
          setActive={setIsCreateSectionModalVisible}
          isPersonalSpace={isPersonalSpace}
        />
      </Router>
      <CommunityUpgradeNudge community={community} />
    </div>
  );
}

/**
 * Decide if the app container should have extra class based on the current path
 * @param {*} currentPath
 * @param {*} community
 * @param {*} user
 * @returns
 */
function getExtraClassForAppContainerUsingPath(
  currentPath = "",
  community,
  user
) {
  let extraClass = "";
  if (user && !community.isCommunitySwitcherDisabled) {
    extraClass += " three-column-with-community-switcher ";
  }
  // Display two columns layout if the current path is the homepage | leaderboard
  if (
    ["/leaderboard", "", "/", "/events", "/course"].includes(currentPath) ||
    (currentPath.startsWith("/embedded-section/") && community)
  ) {
    extraClass += "two-column ";
  } else if (
    [
      "/settings/members",
      "/settings/leaderboard",
      "/settings/invite",
      "/settings/bulkmail",
      SUBSCRIPTION_PAGE_ROUTE,
      CUSTOM_PUSH_PAGE_ROUTE,
      "/settings/bulkmail/send",
    ].includes(currentPath) &&
    community
  ) {
    extraClass += "one-column ";
  } else if (
    currentPath.startsWith("/direct-message") ||
    currentPath.startsWith("/course/view")
  ) {
    extraClass += "one-column ";
  }

  if (currentPath.startsWith("/course/view")) {
    extraClass += "noTopPadding ";
  }

  return extraClass;
}

const AuthApp = withToast(
  connect(
    (s) => ({
      socket: s.socket,
      notifications: s.notifications,
      groups: s.groups,
      personalGroup: s.personalGroup,
      isLoadingGroups: s.isLoadingGroups,
      chats: s.directMessages.users,
      notificationCentre: s.notificationCentre,
      community: s.community,
      subscriptions: s.subscriptionsPlan,
      mySubscription: s.mySubscription,
    }),
    (d) =>
      bindActionCreators(
        {
          addNewNotification: addNotification,
          setChats: getAllDirectChatsSuccessAction,
          getAllDirectChats,
        },
        d
      )
  )(AuthAppComponent)
);

export default AuthApp;
